import Dropzone from './dropzone/Main.vue'

export default app => {
    app.component('Dropzone', Dropzone)
}
